module.exports = __webpack_public_path__ + "static/img/RU.f5162632.jpg";